import { Field, Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'
import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import canSeeIntegration from 'modules/marketplace/lib/canSeeIntegration'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'

import A3InnuvaContractType from './SpainLegalAndExtras/A3innuvaFields/_ContractType'

interface Props {
  form: Form
  type: ContractFlowType
  contractVersionCountry: string | undefined
  legalEntityCountry: string | undefined
}

const ContractTypeSelect = ({ form, type, contractVersionCountry, legalEntityCountry }: Props) => {
  const { spanishContractData, frenchContractData, germanContractData, portugueseContractData } =
    useLegalEntityContractData()

  const canSeeA3InnuvaIntegration = Boolean(
    canSeeIntegration(integrationCodes.a3innuva, spanishContractData.companyInstallations)
  )

  const isSpanish =
    contractVersionCountry && type === 'fix'
      ? contractVersionCountry === 'es'
      : legalEntityCountry === 'es'
  const isFrench =
    contractVersionCountry && type === 'fix'
      ? contractVersionCountry === 'fr'
      : legalEntityCountry === 'fr'
  const isGerman =
    contractVersionCountry && type === 'fix'
      ? contractVersionCountry === 'de'
      : legalEntityCountry === 'de'
  const isPortuguese =
    contractVersionCountry && type === 'fix'
      ? contractVersionCountry === 'pt'
      : legalEntityCountry === 'pt'

  let contractTypes
  let contractTypeField: Field
  if (isSpanish) {
    contractTypes = spanishContractData.contractTypes
    contractTypeField = form.get('es_contract_type_id')
  } else if (isFrench) {
    contractTypes = frenchContractData.contractTypes
    contractTypeField = form.get('fr_contract_type_id')
  } else if (isGerman) {
    contractTypes = germanContractData.contractTypes
    contractTypeField = form.get('de_contract_type_id')
  } else if (isPortuguese) {
    contractTypes = portugueseContractData.contractTypes
    contractTypeField = form.get('pt_contract_type_id')
  } else {
    return null
  }

  const options = contractTypes
    .filter((value) => value.archivedAt === null)
    .map((value) => ({
      value: value.id,
      label: value.name,
    }))

  return (
    <>
      {canSeeA3InnuvaIntegration ? (
        <A3InnuvaContractType form={form} spanishContractData={spanishContractData} />
      ) : (
        <Select
          field={contractTypeField}
          label={i18n.t('contract_versions.forms.basic_information.es_contract_type')}
          options={options}
          none={i18n.t('common.none')}
          readonly={!contractTypes.length}
        />
      )}
    </>
  )
}

export default observer(ContractTypeSelect)
